import currencyModelValidator from './currency';

export default currencyModelValidator;
